import {ApplicationStyles, Colors, Metrics} from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	card: {
    	'margin-right': 8,
    	overflow: 'hidden',
	},
	nested: {
        paddingLeft: theme.spacing(4),
        fontSize:'20px'
	},
	gridSeparatorRight: {
		paddingRight: '1%',
	},
	gridSeparatorLeft: {
		paddingLeft: '1%',
	},
	gridSeparatorTop: {
		paddingTop: '16px',
	},
	numericInput: {
		flex: 1,
		width: '100%',
		marginBottom: 8
	},
	buttonsContainer:{
		marginTop: 10,
		marginBottom: 10,
		display: 'flex',
		flex: 1,
		justifyContent: 'flex-end'
	},
	button: {
		marginLeft: 8,
	},
	icon: {
		minWidth: '30px',
        fontSize: '20px'
	},
	itemText: {
		minHeight: 23,
		fontSize: '20px'
	},
	addItem: {
		//display: 'flex',
		//justifyContent: 'flex-end',
	},
	hidden: {
		display: 'none'
	},

	align: {
		display: 'flex',
		flexDirection: 'row',
		marginTop: Metrics.baseMargin,
		marginBottom: Metrics.baseMargin,
        justifyContent: 'space-between',
		alignItems: 'baseline',
	},
	alingBase: {
		alignItems: 'baseline',
	},
	inputSelect: {
		width: '50%',
	},
	flex: {
		alignItems:'center',
		display: 'flex',
		flex: 0.5,
	},
	justifyContentFlexEnd: {
		display: 'flex',
		padding: '0'
	},
	
	content:  {
		display: 'flex',
		flexDirection: 'row'
	},
	dynamicDeleteButton: {
		cursor: 'pointer',
		fontSize: '24px',
		color: '#999',
		transition: 'all 0.3s',
		marginLeft: '2%',
	},
	
	radioContent:  {
		flexDirection: 'row',
		width: '100%',
	},
	principalRoot: {
		color:  '#d9d9d9',
		marginRight:'8px',
	},
	root: {
		color:  '#d9d9d9',
		width: '16px',
		marginRight:'8px',
	},
	checkRoot: {
		color: '#999',
		"&$checked": {
		  color: '#5CBF69'
		}
	  },
	  successIcon: {
		color: '#5CBF69',
	  },
	  successCommentIcon:{
		  color:'#FF9666'
	  },
	  overrides: {
        MuiFormControlLabel: {
            label: {
                fontSize: '12px',
            }
        }
    }
	  
}));


export const styles = ({
	...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
    addButton: {
    	color: Colors.primary,
    },
    radioStyle: {
    	display: 'block',
      	height: '30px',
      	lineHeight: '30px',
	}
})

